export const GET_MEMBERVALIDATION_INFO_LOADING = 'REDUX_SAGA_GET_MEMBERVALIDATION_INFO_LOADING';
export const MEMBERVALIDATION_DATA_SUCCESS = 'REDUX_SAGA_MEMBERVALIDATION_DATA_SUCCESS';
export const MEMBERVALIDATION_DATA_ERROR = 'REDUX_SAGA_MEMBERVALIDATION_DATA_ERROR';
export const MEMBERVALIDATION_DATA_RESET = 'REDUX_SAGA_MEMBERVALIDATION_DATA_RESET';
export const MEMBERVALIDATION_LOADING_RESET = 'REDUX_SAGA_MEMBERVALIDATION_LOADING_RESET';
export const GET_MEMBERVALIDATION_START_LOADING = 'REDUX_SAGA_GET_MEMBERVALIDATION_START_LOADING';

export const actionGetMemberValidation = (dispatch, memberNo, lastName, email, phone, street, checkDate) => {
    dispatch({
        type: GET_MEMBERVALIDATION_INFO_LOADING,
        payload: {
            memberNo: memberNo, lastName: lastName,
            email: email, phone: phone, street: street, checkDate: checkDate
        }
    })
};

export const actionResetMemberValidation = (dispatch) => {
    dispatch({ type: MEMBERVALIDATION_DATA_RESET });
}

export const actionEndMemberValidationLoading = (dispatch) => {
    dispatch({ type: MEMBERVALIDATION_LOADING_RESET });
}

export const actionStartLoadingOnRemoveMembership = (dispatch) => {
    dispatch({ type: GET_MEMBERVALIDATION_START_LOADING });
}

export const actionSetErrorMemberValidation = (dispatch, err) => {
    dispatch({ type: MEMBERVALIDATION_DATA_ERROR, error: err });

}   